import FormTemplates from '@/models/FormTemplates';

export const cloneFormTemplate = (itemId, items) => {
    const item = items.find(({ id }) => id === itemId);
    return new FormTemplates(item);
}
